export default "__VITE_ASSET__Bs8VjIji__"